module.exports = __webpack_public_path__ + "img/Icon_Linkedin.cc5d2a6a.svg";